module.exports = __webpack_public_path__ + "static/media/sensable_71.43232bae.png";